
import { Component, Prop, Vue } from "vue-property-decorator";
import { UploadableScanningResult } from "@/models/uploadable";
import { ScanningResult } from "@gigalot/data-models";

type RecordConfig = {
  title: string;
  loadAction: string;
};

@Component
export default class RecordsList extends Vue {
  @Prop({ required: true }) readonly recordType!: string;

  items: UploadableScanningResult[] = [];

  get moment() {
    return this.$store.state.moment;
  }

  get recordConfig(): RecordConfig {
    const configs: { [key: string]: RecordConfig } = {
      count: {
        title: "Count Records",
        loadAction: "data/getRollCalls",
      },
      headCount: {
        title: "Head Count Records",
        loadAction: "data/getHeadCounts",
      },
      groupWeigh: {
        title: "Group Weigh Records",
        loadAction: "data/getGroupWeighs",
      },
      groupTreatment: {
        title: "Group Treatment Records",
        loadAction: "data/getGroupTreatments",
      },
      groupVaccination: {
        title: "Group Vaccination Records",
        loadAction: "data/getGroupVaccinations",
      },
      dispatchToAbattoir: {
        title: "Dispatch To Abattoir Records",
        loadAction: "data/getDispatchesToAbattoirs",
      },
      hospital: {
        title: "Hospital Records",
        loadAction: "data/getHospitalResults",
      },
      mortality: {
        title: "Mortality Records",
        loadAction: "data/getMortalities",
      },
    };

    return (
      configs[this.recordType] || {
        title: "Records",
        loadAction: "data/getRollCalls",
      }
    );
  }

  get pageTitle() {
    return this.recordConfig.title;
  }

  created() {
    this.$store.commit("navFuncs", {
      save: undefined,
      back: () => {
        this.$router.go(-1);
      },
    });
  }

  async mounted() {
    this.items = await this.$store.dispatch(this.recordConfig.loadAction);
    this.items.sort(this.sortOnTime(false));
  }

  sortOnTime(ascending: boolean) {
    return (a: UploadableScanningResult, b: UploadableScanningResult) => {
      let ret = 0;
      if (a.time < b.time) ret = -1;
      if (a.time === b.time) ret = 0;
      if (a.time > b.time) ret = 1;
      if (!ascending) ret *= -1;
      return ret;
    };
  }

  formatTime(time: string) {
    return this.moment(time).format("YYYY-MM-DD HH:mm");
  }

  groupWeighQuantity(scanningResult: ScanningResult) {
    let totalQty = scanningResult.mass.map((me) => me.quantity as number).reduce((p, c) => p + c);
    if (totalQty < scanningResult.tags.length) totalQty = scanningResult.tags.length;
    return totalQty;
  }

  groupWeighMass(scanningResult: ScanningResult) {
    let qty = this.groupWeighQuantity(scanningResult);
    let totMass = scanningResult.mass.map((me) => me.mass).reduce((p, c) => p + c);
    let avgMass = qty > 0 ? Math.round(totMass / qty) : "";
    return `${totMass}kg (${avgMass}kg average)`;
  }
}
